import { ReloadOutlined } from "@ant-design/icons";
import { Button, Space, Table, type TableProps, Typography } from "antd";
import type { ReactNode } from "react";

type EnterpriseToolbar = {
  reload?: boolean;
  onReload?: () => void;
  extra?: ReactNode;
  /** Bulk action buttons shown when rows are selected */
  bulkActions?: ReactNode;
  /** Number of selected rows — shown as "Выбрано N" */
  selectedCount?: number;
};

export type EnterpriseTableProps<T extends object> = TableProps<T> & {
  toolbar?: EnterpriseToolbar;
};

export default function EnterpriseTable<T extends object>({
  toolbar,
  pagination,
  ...props
}: EnterpriseTableProps<T>) {
  const showToolbar =
    toolbar &&
    (toolbar.reload || toolbar.extra || toolbar.bulkActions || (toolbar.selectedCount ?? 0) > 0);

  return (
    <Space orientation="vertical" size="middle" style={{ width: "100%" }}>
      {showToolbar ? (
        <Space style={{ justifyContent: "space-between", width: "100%", flexWrap: "wrap" }}>
          <Space wrap>
            {toolbar.reload ? (
              <Button
                icon={<ReloadOutlined aria-hidden />}
                onClick={toolbar.onReload}
                disabled={!toolbar.onReload}
              >
                Обновить
              </Button>
            ) : null}
            {toolbar.bulkActions}
            {(toolbar.selectedCount ?? 0) > 0 && (
              <Typography.Text type="secondary">Выбрано {toolbar.selectedCount}</Typography.Text>
            )}
          </Space>
          <Space>{toolbar.extra}</Space>
        </Space>
      ) : null}
      <Table<T> pagination={pagination ?? false} {...props} />
    </Space>
  );
}
